import { Outlet } from "react-router-dom";
import RouteSeo from "../components/RouteSeo";
import Footer from "./Footer";
import MenuNavbar from "./MenuNavbar";

function Layout() {
  return (
    <>
      <RouteSeo />
      <MenuNavbar />
      <Outlet />
      <Footer />
    </>
  );
}

export default Layout;
